const getService = (context, name) => {
    const service = context.services && context.services[name]

    if (typeof service !== 'function') {
        throw new Error(`Send Reply requires services.${name}()`)
    }

    return service
}

const createSendReplyController = ({ context, reportError }) => Object.freeze({
    flush() {
        return Promise.resolve()
    },
    async handleAction(action) {
        if (action.type !== 'terminal.execute') {
            throw new Error(`Unsupported Send Reply action "${action.type}"`)
        }

        try {
            const result = await getService(context, 'sendReceivedRequestReply')()
            reportError(null)

            return result
        } catch (error) {
            reportError(error)
            throw error
        }
    },
})

export { createSendReplyController }
export default createSendReplyController
